export default __webpack_public_path__ + "azure-iot-hub-logo.38c01d6a06218752f006.png";